export enum PictureManagerViewModel {
    Pictures = 'pictures'
}
